import React, { Component } from "react"
import PropTypes from "prop-types"
import { Table } from "elemental-react16"
import { Button } from "semantic-ui-react"
import ProductCount from "components/Product/ProductCount"
import Price from "components/Price/Price"
import _ from "lodash"

export default class ProductTable extends Component {
  static propTypes = {
    list:     PropTypes.object,
    cart:     PropTypes.object,
    onChange: PropTypes.func,
    products: PropTypes.array,
  }
  
  constructor() {
    super()
  }
  
  render() {
    let { list, cart, products, onChange } = this.props
    let positions = list || products
    if ( list ) positions = list.products
    let rows = _.map( positions, ( product, index ) => {
      return (
        <ProductRow key={index} index={index} onChange={onChange} list={list} cart={cart} product={product}/>
      )
    } )
    return (
      <div className="table-container" style={{overflowX: "auto"}}>
        <Table>
          <colgroup>
            <col width="50"/>
            <col width=""/>
            <col width="30%"/>
            <col width="10%"/>
            <col width="10%"/>
          </colgroup>
          <thead>
          <tr>
            
            <th>&nbsp;</th>
            <th>{translate("article")}</th>
            <th>&nbsp;</th>
            <th>{translate("deliverable")}</th>
            <th>{translate("Stückpreis")}</th>
            <th>{translate("PU")}</th>
            <th>{translate("sum")}</th>
            <th style={{ textAlign: "right" }}>{translate( "amount (VE)" )}</th>
          </tr>
          </thead>
          <tbody>
          {rows}
          </tbody>
        </Table>
      </div>
    )
  }
}

const ProductRow = ( { product, onChange, list, cart, index } ) => {
  return (
    <tr>
      <td>
        {cart ? <CartActions cart={cart} product={product}/> : null}
      </td>
      <td>
        <img
          className="db center"
          height="34"
          src={product.img_src_small}
          alt=""/>
      </td>
      <td>
        <strong>{product.article_nr}</strong> <span className="product-title">{product.title}</span>
        <div className="black-60 f6">{product.extras.Farbe}, {product.extras.Groesse}</div>
      </td>
      <td><span className="f6">{product.getNotice("tiny")}</span></td>
      <td><Price>{product.price}</Price></td>
      <td>1 {translate("PU")} à {product.unit_multi} {translate( "cart.piece" )}</td>
      <td><Price>{product.price * product.count * product.unit_multi}</Price></td>
      <td className="tr">
        <ProductCount product={product} onChange={onChange}/>
        {list ? <ListActions list={list} product={product}/> : null}
      </td>
    </tr>
  )
}

ProductRow.propTypes = {
  index:    PropTypes.any,
  list:     PropTypes.object,
  cart:     PropTypes.object,
  onChange: PropTypes.func,
  product:  PropTypes.any,
}

const CartActions = ( { cart, product } ) => {
  return (
    <Button
      onClick={() => {
        cart.remove( product )
      }}
      basic
      icon="cancel"
      size="tiny"
    />
  )
}

CartActions.propTypes = {
  cart:    PropTypes.object,
  product: PropTypes.object,
}

const ListActions = ( { list, product } ) => {
  return (
    <Button.Group className="pl2">
      <Button
        icon="trash"
        onClick={() => {
          list.remove( product )
        }}
      />
      <Button
        icon="cart"
        onClick={() => {
          list.toCart( product )
        }}
      />
    </Button.Group>
  )
}

ListActions.propTypes = {
  list:    PropTypes.object,
  product: PropTypes.object,
}



// WEBPACK FOOTER //
// ./src/theme/giraffiti/components/Product/ProductTable.js